<template>
  <div class="transaction-form main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title text-capitalize">{{ termPlural }}</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row class="mb-3">
          <b-col cols="12" class="mt-n3">
            <a class="cj-label" @click="goBack" href="#"><i class="fa fa-long-arrow-left mr-1"></i>Voltar</a>
          </b-col>
        </b-row>
        <validation-observer ref="transactionForm" v-slot="{ invalid }">
          <b-row class="mb-3">
            <b-col cols="12">
              <div class="box-cj">
                <div class="header">
                  <p class="title">Informações d{{ letter }} {{ termSingular }}</p>
                </div>
                <div class="content">
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">Procedimento TUSS (opcional)</label>
                      <multiselect ref="multiselectTuss" :preserveSearch="true" v-model="procedureForm.tuss_procedure" :options="tussProcedures" track-by="name" label="name" :loading="isLoadingTussProcedures" :internal-search="false" :options-limit="20" :limit="5" :limit-text="limitTussProcedures" :max-height="200" @search-change="findTussProcedures" :showLabels="false" :disabled="!((procedureForm.id == null && canAdd) || (procedureForm.id != null && canEdit))" placeholder="Selecione">
                        <template slot="clear">
                          <div class="multiselect__clear" v-if="procedureForm.tuss_procedure != null" @mousedown.prevent.stop="procedureForm.tuss_procedure = null"></div>
                        </template>
                        <template slot="noOptions">
                          <div>
                            Digite para pesquisar procedimentos TUSS...
                          </div>
                        </template>
                        <template slot="noResult" v-if="!isLoadingTussProcedures">
                          <div>
                            Nenhum procedimento TUSS encontrado...
                          </div>
                        </template>
                      </multiselect>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col cols="12" md="8">
                      <label class="cj-label">Nome do procedimento</label>
                      <validation-provider name="nome do procedimento" :rules="{ required: true }" v-slot="{ errors }">
                        <b-form-input type="text" v-model="procedureForm.name" :disabled="!((procedureForm.id == null && canAdd) || (procedureForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col cols="12" md="4">
                      <label class="cj-label">Código interno</label>
                      <b-form-input type="text" v-model="procedureForm.internal_code" :disabled="!((procedureForm.id == null && canAdd) || (procedureForm.id != null && canEdit))" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col cols="12" md="3">
                      <label class="cj-label">Duração média</label>
                      <validation-provider name="duração média" :rules="{ required: true, regex: '^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$' }" v-slot="{ errors }" :bails="false">
                        <b-form-input type="text" v-model="procedureForm.execution_time" v-mask="'##:##'" :class="{ 'error': errors.length > 0 }" :disabled="!((procedureForm.id == null && canAdd) || (procedureForm.id != null && canEdit))"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col cols="12" md="3">
                      <validation-provider name="valor" :rules="{ required: true }" v-slot="{ errors }">
                        <label class="cj-label">Valor</label>
                        <money v-model="procedureForm.value" class="form-control mb-2" :disabled="!((procedureForm.id == null && canAdd) || (procedureForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }"></money>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </div>
                <div class="footer" v-if="((procedureForm.id == null && canAdd) || (procedureForm.id != null && canEdit) || canRemove)">
                  <b-button variant="primary" class="mr-3" :disabled="!canPerformAction || !((procedureForm.id == null && canAdd) || (procedureForm.id != null && canEdit))" @click="saveProcedure">Salvar</b-button>
                  <b-button variant="danger" v-if="procedureForm.id != null && canRemove" @click="deleteProcedure">Excluir</b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </validation-observer>
      </div>
    </b-container>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        leavingPage: false,
        user: null,

        termSingular: 'procedimento',
        termPlural: 'procedimentos',
        url: 'procedimentos',
        letter: 'o',
        newTerm: 'cadastrar-procedimento',
        module: 'procedures',

        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,
        canManage: true,
        canPerformAction: true,

        procedureForm: {
          id: null,
          name: '',
          tuss_procedure: null,
          internal_code: '',
          value: '',
          execution_time: '00:30:00',
        },

        tussProcedures: [],
        isLoadingTussProcedures: false
      }
    },
    watch: {
      'procedureForm.tuss_procedure': {
        handler(newValue) {
          if(this.procedureForm.tuss_procedure != null && this.procedureForm.name.length == 0) {
            this.procedureForm.name = this.procedureForm.tuss_procedure.description;
          }
        }
      },
      'procedureForm.value': {
        handler(newValue) {
          if(this.split) {
            let splitValue = newValue/parseInt(this.splitForm.times);
            this.splitForm.value = splitValue;
          }
        }
      }
    },
    async mounted () {
      this.user = JSON.parse(localStorage.getItem('user'));

      this.canSee = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY')?true:this.helpers.checkPermission(this.module, 'can_see');
      this.canAdd = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY')?true:this.helpers.checkPermission(this.module, 'can_add');
      this.canEdit = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY')?true:this.helpers.checkPermission(this.module, 'can_edit');
      this.canRemove = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY')?true:this.helpers.checkPermission(this.module, 'can_remove');
      this.canManage = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY')?true:this.helpers.checkPermission(this.module, 'can_manage');

      if(this.canSee == false) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({ path: '/' });
        return;
      }

      this.eventBus.$emit('IS_LOADING', true);
      this.canPerformAction = false;

      if(this.$route.params.id != this.newTerm) {
        await this.api.getProcedure(this.$route.params.id).then(res => {
          this.canPerformAction = true;
          if(this.leavingPage) {
            return;
          }

          let procedureData = res.data;

          this.procedureForm = {
            id: procedureData.id,
            name: procedureData.name,
            tuss_procedure: (procedureData.tuss_procedure != null) ? {
              value: procedureData.tuss_procedure.id,
              description: procedureData.tuss_procedure.description,
              name: procedureData.tuss_procedure.code + ' - ' + procedureData.tuss_procedure.description
            } : null,
            internal_code: procedureData.internal_code,
            value: procedureData.value,
            execution_time: procedureData.execution_time
          };

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Procedure', res);
        }).catch(err => {
          if(this.leavingPage) {
            return;
          }
          this.$router.push({path: '/' + this.url});

          this.$swal('Ops...', 'Não conseguimos carregar este ' + this.termSingular + '! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Procedure', err.response);
        });
      } else {
        this.canPerformAction = true;
      }
      this.eventBus.$emit('IS_LOADING', false);
    },
    methods: {
      async saveProcedure() {
        if(!this.canPerformAction || !((this.procedureForm.id == null && this.canAdd) || (this.procedureForm.id != null && this.canEdit)))
          return false;

        this.canPerformAction = false;
        this.eventBus.$emit('IS_LOADING', true);

        const isValid = await this.$refs.transactionForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        let procedureData = {
          id: this.procedureForm.id,
          name: this.procedureForm.name,
          tuss_procedure_id: (this.procedureForm.tuss_procedure != null)?this.procedureForm.tuss_procedure.value:null,
          internal_code: this.procedureForm.internal_code,
          value: this.procedureForm.value,
          execution_time: this.procedureForm.execution_time
        };

        if (this.procedureForm.id == null) {
          this.api.storeProcedure(procedureData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            if (res.status == 201) {
              this.$swal('Uhull \\o/', 'O '+this.termSingular+' foi criado com sucesso!', 'success').then(() => {
                this.$router.push({path: '/' + this.url});
              });
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao criar o '+this.termSingular+'! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Store Procedure', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            let msg = 'Não conseguimos criar este '+this.termSingular+'! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

            switch (err.response.status) {
              case 422: msg = err.response.data.errors.join('\r\n'); break;
            }

            this.$swal('Ops...', msg, 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Store Procedure', err.response);
          });
        } else {
          this.api.updateProcedure(this.procedureForm.id, procedureData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            if (res.status == 200) {
              this.$swal('Uhull \\o/', 'O ' + this.termSingular + ' foi atualizado com sucesso!', 'success').then(() => {
                this.$router.push({path: '/' + this.url});
              });
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao atualizar o ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Update Procedure', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            let msg = 'Não conseguimos atualizar este ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

            switch (err.response.status) {
              case 422: msg = err.response.data.errors.join('\r\n'); break;
            }

            this.$swal('Ops...', msg, 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Update Procedure', err.response);
          });
        }
      },

      async deleteProcedure() {
        if(this.canRemove) {
          let doCancel = false;

          await this.$swal({
            title: 'Você tem certeza?',
            text: 'Esta ação não poderá ser desfeita!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancelar',
            focusCancel: true
          }).then((res) => {
            if(res.value) {
              doCancel = true;
            }
          });

          if(doCancel) {
            this.canPerformAction = false;
            this.eventBus.$emit('IS_LOADING', true);
            this.api.deleteProcedure(this.procedureForm.id).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              if (res.status == 204) {
                this.$swal('Uhull \\o/', 'O ' + this.termSingular + ' foi excluído com sucesso!', 'success').then(() => {
                  this.$router.push({path: '/' + this.url});
                });
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao excluir o ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error')
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Delete Procedure', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              this.$swal('Ops...', 'Não conseguimos excluir este ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Delete Procedure', err.response);
            });
          }
        }
      },

      limitTussProcedures(qty) {
        return 'e '+qty+' outros procedimentos';
      },

      findTussProcedures(query) {
        this.tussProcedures = [];
        if(query.length >= 3 && !this.isLoadingTussProcedures) {
          this.isLoadingTussProcedures = true;
          this.api.getTussProcedures({ name: query }).then(res => {
            if(this.leavingPage) {
              return;
            }
            this.isLoadingTussProcedures = false;

            res.data.data.forEach(procedure => {
              this.tussProcedures.push({
                value: procedure.id,
                description: procedure.description,
                name: procedure.name
              });
            });
          }).catch(err => {
            if(this.leavingPage) {
              return;
            }
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error TUSS Procedures', err.response);
          });
        }
      },

      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },

      goBack() {
        this.$router.push({path: '/' + this.url});
      }
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .transaction-form {
    padding: 20px 0;

    .text1 {
      font-size: 14px;
      color: $cadetGray;
      margin-bottom: 0;
    }


  }
</style>
